import { objectGetKeys } from '../../../utils/ieCompatibility'

export enum champsMenuRechercheEnum {
	location = 'location',
	typeBien = 'typeBien',
	budget = 'budget',
	rechercheAvancee = 'rechercheAvancee'
}

export enum budgetEnum {
	min = 'min',
	max = 'max'
}

export enum rechercheAvanceeEnum {
	meuble = 'meuble',
	surface = 'surface',
	combienDeChambre = 'combienDeChambre',
	quelEtage = 'quelEtage',
	dernierEtage = 'dernierEtage',
	prestation = 'prestation',
	parking = 'parking',
	pmr = 'pmr',
	reference = 'reference'
}

export const offresCrmIdFilter = 'offresCrmId'

export enum localisationRechercheEnum {
	paris = '75',
	paris1 = '75001',
	paris2 = '75002',
	paris3 = '75003',
	paris7 = '75007',
	paris8 = '75008',
	paris9 = '75009',
	paris11 = '75011',
	paris12 = '75012',
	paris13 = '75013',
	paris14 = '75014',
	paris15 = '75015',
	paris16 = '75016',
	paris17 = '75017',
	paris18 = '75018',
	paris20 = '75020',
	defense = '92',
	boulogne = '92100',
	avray = '92410',
	bordeaux = '33'
}

export const getKeyFromLocalisationRechercheValue = (value: string) => objectGetKeys(localisationRechercheEnum).find((localisationRecherche) => localisationRechercheEnum[localisationRecherche as keyof typeof localisationRechercheEnum] === value) || ''

export const toutesLesLocalisations = [
	getKeyFromLocalisationRechercheValue(localisationRechercheEnum.paris),
	getKeyFromLocalisationRechercheValue(localisationRechercheEnum.avray),
	getKeyFromLocalisationRechercheValue(localisationRechercheEnum.boulogne),
	getKeyFromLocalisationRechercheValue(localisationRechercheEnum.defense),
	getKeyFromLocalisationRechercheValue(localisationRechercheEnum.bordeaux)
]

export enum typeBienRechercheEnum {
	studio = 'studio',
	chambre = 'chambre',
	piece2 = 'piece2',
	piece3 = 'piece3',
	piece4 = 'piece4',
	piece5 = 'piece5',
	piece6 = 'piece6',
	parkingVoiture = 'parkingVoiture',
	parkingMoto = 'parkingMoto'
}

export const biensTypeAppartement = objectGetKeys(typeBienRechercheEnum).filter((typeBienRecherche) => typeBienRecherche !== typeBienRechercheEnum.parkingMoto && typeBienRecherche !== typeBienRechercheEnum.parkingVoiture)
export const biensTypeParking = objectGetKeys(typeBienRechercheEnum).filter((typeBienRecherche) => typeBienRecherche === typeBienRechercheEnum.parkingMoto || typeBienRecherche === typeBienRechercheEnum.parkingVoiture)

export enum surfaceEnum {
	min = 'min',
	max = 'max'
}

export enum nombreChambreEnum {
	une = '1',
	deux = '2',
	trois = '3',
	quatre = '4',
	cinq = '5+'
}

export enum etageEnum {
	rdc = 'RDC',
	un = '1',
	deux = '2',
	trois = '3',
	quatre = '4',
	cinq = '5',
	six = '6+'
}

export enum prestationsEnum {
	balcon = 'balcon',
	terrasse = 'terrasse',
	loggia = 'loggia',
	jardinPrivatif = 'jardin',
	gardien = 'gardien',
	localVelos = 'local_velos',
	espacesVerts = 'espaces_verts',
	ascenseur = 'ascenseur',
	cave = 'cave',
	possibiliteParking = 'possibilite_parking',
	cuisineSemiEquipee = 'cuisine_semi',
	cuisineOuverte = 'cuisine_ouverte',
	cuisineSeparee = 'cuisine_separee'
}

export enum parkingEnum {
	boxPetit = 221310011,
	boxSimple = 221310012,
	boxDouble = 221310008,
	parkingCouvertPetit = 221310047,
	parkingCouvertSimple = 221310048,
	parkingCouvertDouble = 221310044,
	parkingCouvertTripe = 221310078,
	parkingExterieurSimple = 221310052,
	parkingExterieurDouble = 221310049,
	parkingBorneElectrique = 100000000,
	boxMoto = 221310009,
	parkingCouvertMoto = 221310045,
	parkingExterieurMoto = 100000007
}

export const criteresAvancesAppartement = objectGetKeys(rechercheAvanceeEnum).filter((critereRechercheAvancee) => critereRechercheAvancee !== rechercheAvanceeEnum.parking)
